export interface IUpsellHeader {
  text: string;
}

export const UpsellHeader = (props: IUpsellHeader) => {
  const { text } = props;
  return (
    <h2
      automation-id="upsell-message-body-header"
      className="font-sans text-p-18 font-bold leading-6 text-[#1b3a6b]"
    >
      {text}
    </h2>
  );
};
